var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSlrCamera = function SvgSlrCamera(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50pt",
    height: "50pt",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 96.078133,
    x2: 86,
    y2: 119.150307,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 14.78125,
    x2: 86,
    y2: 156.974197,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 14.78125,
    x2: 86,
    y2: 156.974197,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 123.625,
    y1: 14.78125,
    x2: 123.625,
    y2: 156.974197,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 123.625,
    y1: 14.78125,
    x2: 123.625,
    y2: 156.974197,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(46.27451%,36.470589%,88.627452%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(27.843139%,5.882353%,74.509805%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 26.203131,
    x2: 86,
    y2: 38.76181,
    gradientTransform: "matrix(0.290698,0,0,0.290698,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77.64706%,73.725492%,95.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(50.588238%,29.803923%,94.509804%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface9095483"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 25 28.125 C 23.273438 28.125 21.875 29.523438 21.875 31.25 C 21.875 32.976562 23.273438 34.375 25 34.375 C 26.726562 34.375 28.125 32.976562 28.125 31.25 C 28.125 29.523438 26.726562 28.125 25 28.125 Z M 25 28.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 39.0625 20.3125 L 38.28125 20.3125 C 38.28125 19.449219 37.582031 18.75 36.71875 18.75 L 35.15625 18.75 C 34.292969 18.75 33.59375 19.449219 33.59375 20.3125 L 32.375 20.3125 C 32.039062 20.3125 31.742188 20.097656 31.636719 19.777344 L 30.785156 17.226562 C 30.464844 16.269531 29.574219 15.625 28.5625 15.625 L 27.34375 15.625 L 27.34375 14.0625 L 29.6875 14.0625 C 30.980469 14.0625 32.03125 13.011719 32.03125 11.71875 L 32.03125 7.03125 C 32.03125 5.738281 30.980469 4.6875 29.6875 4.6875 L 20.3125 4.6875 C 19.019531 4.6875 17.96875 5.738281 17.96875 7.03125 L 17.96875 11.71875 C 17.96875 13.011719 19.019531 14.0625 20.3125 14.0625 L 22.65625 14.0625 L 22.65625 15.625 L 21.4375 15.625 C 20.425781 15.625 19.535156 16.269531 19.214844 17.226562 L 18.363281 19.78125 C 18.257812 20.097656 17.960938 20.3125 17.625 20.3125 L 16.40625 20.3125 C 16.40625 19.449219 15.707031 18.75 14.84375 18.75 L 13.28125 18.75 C 12.417969 18.75 11.71875 19.449219 11.71875 20.3125 L 10.9375 20.3125 C 9.644531 20.3125 8.59375 21.363281 8.59375 22.65625 L 8.59375 42.96875 C 8.59375 44.261719 9.644531 45.3125 10.9375 45.3125 L 39.0625 45.3125 C 40.355469 45.3125 41.40625 44.261719 41.40625 42.96875 L 41.40625 22.65625 C 41.40625 21.363281 40.355469 20.3125 39.0625 20.3125 Z M 19.53125 11.71875 L 19.53125 7.03125 C 19.53125 6.601562 19.882812 6.25 20.3125 6.25 L 29.6875 6.25 C 30.117188 6.25 30.46875 6.601562 30.46875 7.03125 L 30.46875 11.71875 C 30.46875 12.148438 30.117188 12.5 29.6875 12.5 L 20.3125 12.5 C 19.882812 12.5 19.53125 12.148438 19.53125 11.71875 Z M 24.21875 14.0625 L 25.78125 14.0625 L 25.78125 15.625 L 24.21875 15.625 Z M 19.847656 20.273438 L 20.699219 17.71875 C 20.804688 17.402344 21.101562 17.1875 21.4375 17.1875 L 28.5625 17.1875 C 28.898438 17.1875 29.195312 17.402344 29.300781 17.722656 L 30.152344 20.273438 C 30.15625 20.289062 30.164062 20.300781 30.167969 20.3125 L 19.828125 20.3125 C 19.835938 20.300781 19.839844 20.289062 19.847656 20.273438 Z M 10.15625 35.9375 L 11.71875 35.9375 L 11.71875 34.375 L 10.15625 34.375 L 10.15625 32.8125 L 11.71875 32.8125 L 11.71875 31.25 L 10.15625 31.25 L 10.15625 29.6875 L 11.71875 29.6875 L 11.71875 28.125 L 10.15625 28.125 L 10.15625 26.863281 L 12.75 27.730469 C 13.066406 27.835938 13.28125 28.132812 13.28125 28.46875 L 13.28125 35.59375 C 13.28125 35.929688 13.066406 36.226562 12.75 36.332031 L 10.15625 37.199219 Z M 39.84375 42.96875 C 39.84375 43.398438 39.492188 43.75 39.0625 43.75 L 10.9375 43.75 C 10.507812 43.75 10.15625 43.398438 10.15625 42.96875 L 10.15625 42.1875 L 39.84375 42.1875 Z M 10.15625 40.625 L 10.15625 38.84375 L 13.242188 37.816406 C 14.199219 37.496094 14.84375 36.605469 14.84375 35.59375 L 14.84375 28.46875 C 14.84375 27.457031 14.199219 26.566406 13.242188 26.246094 L 10.15625 25.21875 L 10.15625 22.65625 C 10.15625 22.226562 10.507812 21.875 10.9375 21.875 L 39.0625 21.875 C 39.492188 21.875 39.84375 22.226562 39.84375 22.65625 L 39.84375 40.625 Z M 10.15625 40.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 25 25 C 21.554688 25 18.75 27.804688 18.75 31.25 C 18.75 34.695312 21.554688 37.5 25 37.5 C 28.445312 37.5 31.25 34.695312 31.25 31.25 C 31.25 27.804688 28.445312 25 25 25 Z M 25 35.9375 C 22.414062 35.9375 20.3125 33.835938 20.3125 31.25 C 20.3125 28.664062 22.414062 26.5625 25 26.5625 C 27.585938 26.5625 29.6875 28.664062 29.6875 31.25 C 29.6875 33.835938 27.585938 35.9375 25 35.9375 Z M 25 35.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 33.59375 37.5 L 38.28125 37.5 L 38.28125 39.0625 L 33.59375 39.0625 Z M 33.59375 37.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear4)"
    },
    d: "M 36.71875 23.4375 L 35.15625 23.4375 C 34.292969 23.4375 33.59375 24.136719 33.59375 25 C 33.59375 25.863281 34.292969 26.5625 35.15625 26.5625 L 36.71875 26.5625 C 37.582031 26.5625 38.28125 25.863281 38.28125 25 C 38.28125 24.136719 37.582031 23.4375 36.71875 23.4375 Z M 36.71875 23.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear5)"
    },
    d: "M 28.125 10.9375 L 21.875 10.9375 C 21.445312 10.9375 21.09375 10.585938 21.09375 10.15625 L 21.09375 8.59375 C 21.09375 8.164062 21.445312 7.8125 21.875 7.8125 L 28.125 7.8125 C 28.554688 7.8125 28.90625 8.164062 28.90625 8.59375 L 28.90625 10.15625 C 28.90625 10.585938 28.554688 10.9375 28.125 10.9375 Z M 28.125 10.9375 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlrCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slr-camera.dba2a688.svg";
export { ForwardRef as ReactComponent };